import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

export default api;

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Bir hata oluştu";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" • ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const fmtMoney = (v, ccy = "TRY") => {
    if (v == null || isNaN(v)) return "—";
    try {
        return new Intl.NumberFormat("tr-TR", {
            style: "currency",
            currency: ccy,
            maximumFractionDigits: 2,
        }).format(v);
    } catch {
        return `${Number(v).toLocaleString("tr-TR")} ${ccy}`;
    }
};

export const fmtNum = (v, d = 2) => {
    if (v == null || isNaN(v)) return "—";
    return Number(v).toLocaleString("tr-TR", { minimumFractionDigits: d, maximumFractionDigits: d });
};

export const fmtDate = (v) => {
    if (!v) return "—";
    try {
        return new Date(v).toLocaleDateString("tr-TR", { year: "numeric", month: "short", day: "2-digit" });
    } catch {
        return v;
    }
};
